import {
    Box,
    LinearProgress,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import "./Navbar.scss";

export default function Navbar({ stepNames, step }) {
    const { t, i18n } = useTranslation();
    const isMobile = !useMediaQuery((theme) => theme.breakpoints.up("md"));
    const progress = !step ? 100 : ((step + 1) / stepNames.length) * 100;
    return (
        <Box className="navBar">
            <Box className="stepWrapper">
                {!isMobile &&
                    stepNames.map((stepName, index) => {
                        return (
                            <Box
                                className={
                                    Object.prototype.toString
                                        .call(stepName)
                                        .indexOf("Object") > -1
                                        ? "stepItm"
                                        : "stepItm" +
                                          (step === index ? " active" : "")
                                }
                                key={index}
                            >
                                <Typography variant="h6" component="div">
                                    {t("common.step", { step: index + 1 })}
                                </Typography>
                                {Object.prototype.toString
                                    .call(stepName)
                                    .indexOf("Object") > -1 ? (
                                    <>
                                        <Typography
                                            variant="subtitle1"
                                            component="h5"
                                            style={{
                                                whiteSpace: "pre-wrap",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            {stepName?.stepName}
                                        </Typography>
                                        {stepName?.subStep?.map(
                                            (subStepName, subStepIndex) => {
                                                return (
                                                    <Box
                                                        key={subStepIndex}
                                                        className={
                                                            "stepItm" +
                                                            (step ==
                                                            `${index}.${
                                                                subStepIndex + 1
                                                            }`
                                                                ? " active"
                                                                : "")
                                                        }
                                                    >
                                                        <Typography component="h5">
                                                            {`${index + 1}.${
                                                                subStepIndex + 1
                                                            }`}
                                                        </Typography>
                                                        <Typography
                                                            component="h6"
                                                            style={{
                                                                whiteSpace:
                                                                    "pre-wrap",
                                                            }}
                                                        >
                                                            {subStepName}
                                                        </Typography>
                                                    </Box>
                                                );
                                            }
                                        )}
                                    </>
                                ) : (
                                    <Typography
                                        variant="subtitle1"
                                        component="div"
                                        style={{ whiteSpace: "pre-wrap" }}
                                    >
                                        {stepName}
                                    </Typography>
                                )}
                            </Box>
                        );
                    })}
                {isMobile && (
                    <LinearProgress
                        variant="determinate"
                        value={progress}
                        aria-valuemin="0"
                        aria-valuemax="1"
                        aria-valuenow={progress}
                        title={t("common.progressBar")}
                        aria-label={t("common.progressBar")}
                    />
                )}
            </Box>
        </Box>
    );
}
